/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification Connectivity Icon component.
 */
export const NotificationConnectivityIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.78544 17.1216C7.80653 16.5572 6.99352 15.745 6.42825 14.7665C5.86299 13.7881 5.56543 12.6781 5.56543 11.5481C5.56543 10.4182 5.86299 9.30814 6.42825 8.32972C6.99352 7.35131 7.80653 6.53903 8.78544 5.97461' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M15.2095 5.96484C16.193 6.52793 17.0102 7.34084 17.5786 8.32126C18.1471 9.30168 18.4464 10.4148 18.4464 11.5481C18.4464 12.6814 18.1471 13.7946 17.5786 14.775C17.0102 15.7554 16.193 16.5682 15.2095 17.1313' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M12.0026 13.7395C13.2102 13.7395 14.1892 12.7605 14.1892 11.5529C14.1892 10.3452 13.2102 9.36621 12.0026 9.36621C10.7949 9.36621 9.81592 10.3452 9.81592 11.5529C9.81592 12.7605 10.7949 13.7395 12.0026 13.7395Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M6.50198 21.0862C4.82904 20.1195 3.43997 18.7296 2.4742 17.0561C1.50843 15.3826 1 13.4845 1 11.5524C1 9.6202 1.50843 7.72206 2.4742 6.04859C3.43997 4.37512 4.82904 2.98524 6.50198 2.01855' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M17.4644 2C19.1464 2.96405 20.5442 4.35517 21.5162 6.03265C22.4883 7.71013 23.0002 9.6145 23.0002 11.5533C23.0002 13.492 22.4883 15.3964 21.5162 17.0739C20.5442 18.7513 19.1464 20.1425 17.4644 21.1065' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
    </svg>
  );
};

export default NotificationConnectivityIcon;
